import { api } from "../api";

/**
 * bannerFindAllCrudResponse - Function that finds on database all banners by status as crud response data
 * /banners/{status}
 * method GET
 * @async-function
 */
const bannerFindAllCrudResponse = async (token: string, status: string, page: number, size: number) => {
    const response = await api.get(
        `/banners/${status}?page=${page}&size=${size}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default bannerFindAllCrudResponse;
